export enum FinancialAdjustment {
  CREDIT = 'Credit',
  DEBIT = 'Debit',
  NONE = 'None',
}
